import React from 'react';

export default function Terms() {
    const [termsChecked, setTermsChecked] = React.useState(false);
    const [privacyChecked, setPrivacyChecked] = React.useState(false);
    const [agreed, setAgreed] = React.useState(false);

    React.useEffect(() => {
        const agreedValue = localStorage.getItem(
            'termsAndPrivacyAgreed21May2025',
        );
        if (agreedValue === 'true') {
            setAgreed(true);
            return;
        }
    }, []);

    const handleAgree = () => {
        localStorage.setItem('termsAndPrivacyAgreed21May2025', 'true');
        setAgreed(true);
    };

    if (agreed) {
        return null;
    }

    return (
        <div tw="fixed inset-0 backdrop-blur-sm z-50 flex items-center justify-center">
            <div tw="bg-dark rounded-lg p-8 max-w-2xl w-full mx-4 text-gray-100">
                <h2 tw="text-2xl font-bold mb-4">Terms & Privacy</h2>
                <p tw="mb-6">
                    To use this site, you must agree to the following:
                </p>

                <div tw="space-y-4 mb-6">
                    <label tw="flex items-start cursor-pointer">
                        <input
                            type="checkbox"
                            checked={termsChecked}
                            onChange={(e) => setTermsChecked(e.target.checked)}
                            tw="mt-1 mr-3"
                        />
                        <span>
                            I agree to the{' '}
                            <a
                                href="https://thevault.finance/terms"
                                target="_blank"
                                rel="noreferrer"
                                tw="text-blue-400 hover:underline"
                            >
                                Terms of Service
                            </a>
                        </span>
                    </label>

                    <label tw="flex items-start cursor-pointer">
                        <input
                            type="checkbox"
                            checked={privacyChecked}
                            onChange={(e) =>
                                setPrivacyChecked(e.target.checked)
                            }
                            tw="mt-1 mr-3"
                        />
                        <span>
                            I agree to the{' '}
                            <a
                                href="https://thevault.finance/privacy"
                                target="_blank"
                                rel="noreferrer"
                                tw="text-blue-400 hover:underline"
                            >
                                Privacy Policy
                            </a>
                        </span>
                    </label>
                </div>

                <button
                    disabled={!termsChecked || !privacyChecked}
                    onClick={handleAgree}
                    className={`w-full py-2 px-4 rounded ${
                        termsChecked && privacyChecked
                            ? 'bg-blue-600 hover:bg-blue-700 text-white'
                            : 'bg-gray-700 cursor-not-allowed text-gray-400'
                    }`}
                >
                    I Agree
                </button>
            </div>
        </div>
    );
}
